import { Component } from '@angular/core';
import { Icono } from '../icono/icono';

/**
 * Footer de la web pública (Figma: componente `footer`, device=Desktop).
 * Año dinámico según especificación funcional §3.3. Las redes sociales
 * abren en nueva pestaña.
 *
 * Logo y redes son los mismos que el footer del backoffice
 * (`frontend-backoffice/src/components/footer/`): mismo asset de
 * `/logos/`, mismos iconos de `/icons/` y las mismas cuentas.
 */
@Component({
  selector: 'app-footer',
  imports: [Icono],
  template: `
    <footer class="footer">
      <img
        class="footer__logo"
        src="/logos/logo-grey-600.svg"
        alt="Phindi"
        width="95"
        height="32"
      />
      <p class="footer__copy">
        © {{ anio }} Phindi - Todos los derechos reservados.
      </p>
      <div class="footer__social">
        <a
          class="social-btn"
          href="https://www.tiktok.com/@phindi7714"
          target="_blank"
          rel="noopener"
          aria-label="TikTok"
        >
          <svg app-icono nombre="tiktok"></svg>
        </a>
        <a
          class="social-btn"
          href="https://www.instagram.com/phindilovers"
          target="_blank"
          rel="noopener"
          aria-label="Instagram"
        >
          <svg app-icono nombre="instagram"></svg>
        </a>
        <!-- TODO: falta la URL del canal. El backoffice tampoco la tiene
             (apunta a "/"), así que queda el genérico hasta que la definan. -->
        <a
          class="social-btn"
          href="https://www.youtube.com/"
          target="_blank"
          rel="noopener"
          aria-label="YouTube"
        >
          <svg app-icono nombre="youtube"></svg>
        </a>
      </div>
    </footer>
  `,
  styles: `
    .footer {
      height: 72px;
      padding: 16px 48px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: var(--c-neutrals-grey_200);
    }

    .footer__logo {
      display: block;
    }

    .footer__copy {
      margin: 0;
      font-size: 14px;
      line-height: 1.5;
      color: var(--c-neutrals-grey_800);
    }

    .footer__social {
      display: flex;
      align-items: center;
      gap: 16px;
    }

    .social-btn {
      width: 40px;
      height: 40px;
      border-radius: 99999px;
      background: var(--c-neutrals-grey_500);
      color: var(--c-neutrals-grey_25);
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .social-btn svg {
      width: 18px;
      height: 18px;
    }

    .social-btn:hover {
      background: var(--c-neutrals-grey_600);
    }

    /* Mobile (Figma 157-762): logo, redes y copy apilados y centrados */
    @media (max-width: 900px) {
      .footer {
        height: auto;
        flex-direction: column;
        gap: 16px;
        padding: 24px 16px;
      }

      .footer__social {
        order: 2;
      }

      .footer__copy {
        order: 3;
        font-size: 12px;
        text-align: center;
      }
    }
  `,
})
export class Footer {
  /** Año vigente, dinámico (spec §3.3). */
  readonly anio = new Date().getFullYear();
}
